module.exports = __webpack_public_path__ + "img/02_bohle.da4c25a0.jpeg";